<mat-icon [class]="class"
          [ngClass]="{disabled: disabled}"
          (click)="!disabled && onClickE.emit()">{{ icon }}</mat-icon>
